module.exports = __webpack_public_path__ + "img/icon-cart-black.ec22b49c.svg";